import { ReduxStore } from 'store/types';

function createIsLoading(state: ReduxStore): boolean {
  return state.category.create.config.isLoading;
}

export default createIsLoading;
